import axios from 'axios';
import {
  V1_PURCHASE_ORDER,
  V1_SEARCH_PURCHASE_ORDER,
  V1_EXPORT_PURCHASE_ORDER,
  V1_PURCHASE_ORDER_BY_ID,
  V1_PRINT_PURCHASE_ORDER,
  V1_RESEND_EMAIL_PURCHASE_ORDER,
  V1_CREATE_AND_FULFILLED,
  V1_EDIT_PURCHASE_ORDER,
  V1_UPDATE_PURCHASE_ORDER,
} from './constants';

function reject(error) {
  let eobj;
  if (error.response) {
    const { data } = error.response;
    if (data.errors) {
      eobj = new Error(data.errors);
    } else if (data.error) {
      eobj = new Error(data.error[0]);
    } else if (data.message) {
      eobj = new Error(data.message);
    } else {
      eobj = new Error(error.message);
    }
  } else {
    eobj = new Error(error.message);
  }
  return Promise.reject(eobj);
}

export function getSearchPurchaseOrders(params) {
  return axios
    .get(V1_SEARCH_PURCHASE_ORDER, { params, withCredentials: true })
    .catch(reject);
}

export function getExportPurchaseOrder(params) {
  return axios
    .get(V1_EXPORT_PURCHASE_ORDER, { params, withCredentials: true })
    .catch(reject);
}

export function getPurchaseOrderById(id, params?) {
  return axios
    .get(V1_PURCHASE_ORDER_BY_ID(id), { params, withCredentials: true })
    .catch(reject);
}

export function printPurchaseOrder(id) {
  return axios
    .post(V1_PRINT_PURCHASE_ORDER(id), { withCredentials: true })
    .catch(reject);
}

export function resendEmailPurchaseOrder(id, data?, params?) {
  return axios
    .post(V1_RESEND_EMAIL_PURCHASE_ORDER(id), data, {
      params,
      withCredentials: true,
    })
    .catch(reject);
}

export function postPurchaseOrder(data, header) {
  return axios
    .post(V1_PURCHASE_ORDER, data, {
      withCredentials: true,
      headers: header,
    })
    .catch(reject);
}

export function createAndfullfilled(data, header) {
  return axios
    .post(V1_CREATE_AND_FULFILLED, data, {
      withCredentials: true,
      headers: header,
    })
    .catch(reject);
}

export function getEditDataPO(id) {
  return axios
    .get(V1_EDIT_PURCHASE_ORDER(id), { withCredentials: true })
    .catch(reject);
}

export function updateDataPO(id, data) {
  return axios
    .put(V1_UPDATE_PURCHASE_ORDER(id), data, { withCredentials: true })
    .catch(reject);
}
